import React from "react";
import { Link } from "react-router-dom";

export default function Footer({ showRazorpay = false }) {
  return (
    <footer className="footer">
      <nav className="footer-links" aria-label="Policies">
        <Link to="/privacy">Privacy Policy</Link>
        <Link to="/terms">Terms of Use</Link>
        <Link to="/refund">Refund &amp; Cancellation Policy</Link>
        <Link to="/contact">Contact Us</Link>
      </nav>
      <div>
        © {new Date().getFullYear()} Janmabhoomi Group. All rights reserved.
        {showRazorpay && <>&nbsp;·&nbsp; Payments secured by Razorpay.</>}
      </div>
    </footer>
  );
}
